<template>
  <div id="app">
    <router-view v-if="init" />
  </div>
</template>

<script>
import Request from "@/utils/request";
export default {
  name: "App",
  data() {
    return {
      NavList: [],
      init: false,
    };
  },
  provide() {
    return {
      NavList: () => this.NavList,
    };
  },
  mounted() {
    Request.get("/cms-web/category/treelist/academy")
      .then((res) => {
        this.NavList = res;
      })
      .finally(() => {
        this.init = true;
      });
  },
};
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  min-width: 1250px;
}
</style>
